import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { PushApplicationState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';


export const state: PushApplicationState = {
  pushApplications: [],
  pushApplication: undefined,
  pushPlatforms: ['Android','iOS'],
  pushOS: []
};

export const pushApplication: Module<PushApplicationState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
